import React from 'react';
import { CoinData } from '../../data/coinList';
import { Info } from 'lucide-react';

interface MarketInfoProps {
  coin: CoinData;
}

const MarketInfo: React.FC<MarketInfoProps> = ({ coin }) => {
  const formatSupply = (supply: number) => {
    if (supply >= 1e9) return `${(supply / 1e9).toFixed(2)}B`;
    if (supply >= 1e6) return `${(supply / 1e6).toFixed(2)}M`;
    if (supply >= 1e3) return `${(supply / 1e3).toFixed(2)}K`;
    return supply.toLocaleString();
  };

  const circulatingPercentage = coin.max_supply 
    ? (coin.circulating_supply / coin.max_supply) * 100 
    : 0;

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Supply Information</h3>
      <div className="space-y-4">
        <div>
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm text-zinc-400 flex items-center">
              Circulating Supply
              <Info className="w-3 h-3 ml-1" />
            </span>
            <span className="text-sm font-medium">{formatSupply(coin.circulating_supply)} {coin.symbol.toUpperCase()}</span>
          </div>
          {coin.max_supply && (
            <div className="w-full bg-zinc-800 rounded-full h-2">
              <div 
                className="bg-gradient-to-r from-violet-500 to-blue-500 h-2 rounded-full"
                style={{ width: `${Math.min(circulatingPercentage, 100)}%` }}
              />
            </div>
          )}
        </div>

        {coin.max_supply && (
          <div className="flex justify-between items-center">
            <span className="text-sm text-zinc-400">Max Supply</span>
            <span className="text-sm font-medium">{formatSupply(coin.max_supply)} {coin.symbol.toUpperCase()}</span>
          </div>
        )}

        <div className="flex justify-between items-center">
          <span className="text-sm text-zinc-400">Total Supply</span>
          <span className="text-sm font-medium">{formatSupply(coin.circulating_supply * 1.1)} {coin.symbol.toUpperCase()}</span>
        </div>

        <div className="pt-4 border-t border-zinc-800">
          <h4 className="text-sm font-medium mb-3">Popular Exchanges</h4>
          <div className="space-y-2">
            {['Binance', 'Coinbase', 'Kraken', 'KuCoin'].map((exchange) => (
              <div key={exchange} className="flex justify-between items-center">
                <span className="text-sm text-zinc-400">{exchange}</span>
                <span className="text-xs text-zinc-500">{coin.symbol.toUpperCase()}/USDT</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketInfo;